export default "__VITE_ASSET__B$we56su__"